module.exports = __webpack_public_path__ + "img/diy-Setting.884f1c33.svg";